import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { RadioButton, CustomInput } from "components";
import { float6Normalizer } from "validators";
import {
	applyValidatorsIf,
	floatToSixValidation,
	maxValue100,
	onlyPercentToSixFloat,
} from "validators/validation";

import styles from "./tabsChoose.module.scss";

const ERR = ({ setCurrentValueInField, isPaperApplication }) => {
	const handleErrTemplate = () => setCurrentValueInField(true);

	return (
		<div>
			<div className={styles.subHeader}>ERR</div>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "ERR",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Qual V/MC/D, %"
						name="errQualVMCD"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleErrTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "ERR",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Qual Amex, %"
						name="errQualAmex"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleErrTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "ERR",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Qual Offline Debit, %"
						name="errQualOfflineDebit"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleErrTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						normalizeOnBlur={float6Normalizer}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "ERR",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						label="Non-Qual V/MC/D, %"
						name="errNonQualVMCD"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleErrTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "ERR",
						)([maxValue100, floatToSixValidation])}
						normalizeOnBlur={float6Normalizer}
						normalize={onlyPercentToSixFloat}
						label="Non-Qual Amex, %"
						name="errNonQualAmex"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleErrTemplate}
						hideRequiredMark={isPaperApplication}
					/>
					<Field
						component={CustomInput}
						validate={applyValidatorsIf(
							(_value, allValues) =>
								allValues.feeProgram === "ERR",
						)([maxValue100, floatToSixValidation])}
						normalize={onlyPercentToSixFloat}
						normalizeOnBlur={float6Normalizer}
						label="Non-Qual Offline Debit, %"
						name="errNonQualOfflineDebit"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						onChange={handleErrTemplate}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
			<div className={styles.addressTitle}>Pass Card Brand Fees</div>
			<Row>
				<Col md={12}>
					<div className="d-flex">
						<Field
							component={RadioButton}
							value="true"
							className={styles.radioButton}
							name="passCardBrandFees"
							label="Yes"
							type="radio"
							id="yesPassCardBrandFees"
						/>
						<Field
							component={RadioButton}
							value="false"
							className={styles.radioButton}
							name="passCardBrandFees"
							label="No"
							type="radio"
							id="noPassCardBrandFees"
						/>
					</div>
				</Col>
			</Row>
		</div>
	);
};
export default memo(ERR);
